module.exports = __webpack_public_path__ + "static/media/NIKE.f7463481.png";